export default __webpack_public_path__ + "static/media/tilted.7e998d4b.webp";